import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


// state
import state from "@/vue/planning/store/state/state"
import state_datepicker from "@/vue/planning/store/state/datepicker"

// getters
import getter_getters from "@/vue/planning/store/getters/getters"
import getter_dates from "@/vue/planning/store/getters/dates"
import getter_prestations from "@/vue/planning/store/getters/prestations"
import getter_capacity from "@/vue/planning/store/getters/capacity"
import getter_total from "@/vue/planning/store/getters/total"
import getter_select from "@/vue/planning/store/getters/select"
import getter_validity from "@/vue/planning/store/getters/validity"
import getter_fees from "@/vue/planning/store/getters/fees"
import getter_criterias from "@/vue/planning/store/getters/criterias"
import getter_locale from "@/vue/planning/store/getters/locale"
import getter_bookingProcessURL from "@/vue/planning/store/getters/bookingProcessURL"
import getter_packNames from "@/vue/planning/store/getters/packNames"
import getter_package_info_content from "@/vue/planning/store/getters/packageInfoContent"

// mutations
import mutation_mutations from "@/vue/planning/store/mutations/mutations"
import mutation_maps from "@/vue/planning/store/mutations/maps"
import mutation_dates from "@/vue/planning/store/mutations/dates"
import mutation_select from "@/vue/planning/store/mutations/select"
import mutation_response from "@/vue/planning/store/mutations/response"
import mutation_datepicker from "@/vue/planning/store/mutations/datepicker"

// actions
import action_oopsBanner from "@/vue/planning/store/actions/oopsBanner"
import action_cookies from "@/vue/planning/store/actions/cookies"
import action_url from "@/vue/planning/store/actions/url"
import action_filter from "@/vue/planning/store/actions/filter"
import action_select from "@/vue/planning/store/actions/select"
import action_search from "@/vue/planning/store/actions/search"
import action_dropdowns from "@/vue/planning/store/actions/dropdowns"
import action_loading from "@/vue/planning/store/actions/loading"
import action_windowClicked from "@/vue/planning/store/actions/windowClicked"
import action_reserveClick from "@/vue/planning/store/actions/reserveClick"


const store = new Vuex.Store({
	state: {
		...state,
		...state_datepicker,
	},

	getters: {
		...getter_getters,
		...getter_dates,
		...getter_prestations,
		...getter_capacity,
		...getter_total,
		...getter_select,
		...getter_validity,
		...getter_fees,
		...getter_criterias,
		...getter_locale,
		...getter_bookingProcessURL,
		...getter_packNames,
		...getter_package_info_content
	},

	mutations: {
		...mutation_mutations,
		...mutation_maps,
		...mutation_dates,
		...mutation_select,
		...mutation_response,
		...mutation_datepicker,
	},

	actions: {
		...action_oopsBanner,
		...action_cookies,
		...action_url,
		...action_filter,
		...action_select,
		...action_search,
		...action_dropdowns,
		...action_loading,
		...action_windowClicked,
		...action_reserveClick,
	}
});

export const useStore = () => store

export default store